import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import {
  FormControl,
  InputLabel,
  Select,
  makeStyles,
  MenuItem,
} from "@material-ui/core";

import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: "1rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const ServicesEditReuse = (props) => {
  const classes = useStyles();
  const back = () => {
    props.onChange(5);
    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    formData.currentState = 4;
    formData.runingTrack = 5;
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  const onSubmit = () => {
    //props.onChange(4);
    window.scroll(0, 0);
  };
  const [state, setState] = useState({
    UoM: "",
  });
  const selecthandleChange = (e) => {
    setState({
      UoM: e.target.value,
    });
    formikCustom.setFieldValue("uom", e.target.value);
    formik.setFieldValue("sizes[0].uom", e.target.value);
  };
  const [deleteIndex, setDeleteIndex] = useState();

  const [showDeleteModal, onShowDeleteModal] = useState(false);

  const handleCloseDeleteModal = () => onShowDeleteModal(false);

  const [showDetails, setShowDetails] = useState(false);
  const handleShowDetails = () => setShowDetails(true);
  const handleCloseDetails = () => setShowDetails(false);

  var flagCall = false;

  const validate = (values) => {
    const errors = {};

    if (!values.description) {
      errors.description = "Please add size description";
    }
    if (!values.price) {
      errors.price = "Please enter price";
    }
    if (!values.pax) {
      errors.pax = "Please enter pax";
    }
    // if (!values.size) {
    //   errors.size = "Please enter size";
    // }
    // if (!values.uom) {
    //   errors.uom = "Please select uom";
    // }

    return errors;
  };

  const onClickAddNew = (e) => {
    flagCall = true;
    e.preventDefault();
    formikCustom.handleSubmit();
  };

  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);

  const formikCustom = useFormik({
    initialValues: {
      price: "",
      pax: "",
      calories: "",
      size: "",
      uom: "",
      description: "",
      isDefault: false,
      available: true,
    },
    validate,

    onSubmit: (values) => {
      props.updatedData(values);
      formikCustom.resetForm();
    },
  });

  const onSuccess = () => {
    props.onChange(7);
    window.scroll(0, 0);
  };
  const formik = useFormik({
    initialValues: {
      itemSize: "",
      sizes: [{ price: "", pax: "", size: "", uom: "" }],
      size: [],
    },
    validate,
    validationSchema: yup.object({
      itemSize: yup.string().required("Please select size"),
      //size: yup.array().min(1),
      // size: yup.array().of(
      //   yup.object().shape({
      //     price: yup.string().required("Please enter price"),
      //   })
      // ),
    }),
    onSubmit: (values) => {
      let formData = {};
      if (values.itemSize === "SINGLE") {
        values.size = values.sizes;
      }
      if (values.size.length < 1) {
        Alert.error(`<h4> Please add atleast one item size</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        // /delete values.sizes;
        formData.itemSize = values.itemSize;
        formData.size = values.size;

        const token = props.auth.user.accessToken;
        formData.currentState = 6;
        formData.runingTrack = 7;
        props.update_item_menu_setup(
          props.activeItemId,
          formData,
          token,
          onSuccess
        );
      }
    },
  });

  const clearForm = (e) => {
    e.preventDefault();
    formikCustom.resetForm();
  };

  useEffect(() => {
    formikCustom.setValues(props.data);
    setState({
      ...state,
      UoM: props.data.uom,
    });
  }, [props.data]);

  return (
    <React.Fragment>
      <Row>
        <Col md={10} className="pb-3">
          <NewInputText
            disabled={true}
            labelText="Add Item Name"
            extraClass={`mb-1 w-100 ${
              formikCustom.errors.description &&
              formikCustom.touched.description
                ? "enError"
                : ""
            }`}
            name="description"
            onChange={formikCustom.handleChange}
            value={formikCustom.values.description}
            onFocusOut={formikCustom.handleBlur}
          />
          {formikCustom.errors.description &&
          formikCustom.touched.description ? (
            <div className="pho_14_regular text-danger">
              {formikCustom.errors.description}
            </div>
          ) : null}
        </Col>

        <Col md={3} className="pb-3">
          <NewInputText
            inputType="number"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            labelText="Item Price"
            extraClass={`mb-1 ${
              formikCustom.errors.price && formikCustom.touched.price
                ? "enError"
                : ""
            }`}
            name="price"
            onChange={formikCustom.handleChange}
            value={formikCustom.values.price}
            onFocusOut={formikCustom.handleBlur}
          />
          {formikCustom.errors.price && formikCustom.touched.price ? (
            <div className="pho_14_regular text-danger">
              {formikCustom.errors.price}
            </div>
          ) : null}
        </Col>
        <Col md={7}>
          <Row>
            <Col md={4} className="pb-3">
              <NewInputText
                disabled={true}
                labelText="Serving PAX"
                inputType="number"
                extraClass={`mb-1 ${
                  formikCustom.errors.pax && formikCustom.touched.pax
                    ? "enError"
                    : ""
                }`}
                name="pax"
                onChange={formikCustom.handleChange}
                value={formikCustom.values.pax}
                onFocusOut={formikCustom.handleBlur}
              />
              {formikCustom.errors.pax && formikCustom.touched.pax ? (
                <div className="pho_14_regular text-danger">
                  {formikCustom.errors.pax}
                </div>
              ) : null}
            </Col>
            <Col md={4} className="pb-3">
              <NewInputText
                disabled={true}
                labelText="Calories"
                inputType="number"
                extraClass={`mb-1 ${
                  formikCustom.errors.calories && formikCustom.touched.calories
                    ? "enError"
                    : ""
                }`}
                name="calories"
                onChange={formikCustom.handleChange}
                value={formikCustom.values.calories}
                onFocusOut={formikCustom.handleBlur}
              />
              {formikCustom.errors.calories && formikCustom.touched.calories ? (
                <div className="pho_14_regular text-danger">
                  {formikCustom.errors.calories}
                </div>
              ) : null}
              {/* <NewInputText
                disabled={true}
                labelText="Serving Size"
                inputType="number"
                extraClass={`mb-1 ${
                  formikCustom.errors.size && formikCustom.touched.size
                    ? "enError"
                    : ""
                }`}
                name="size"
                onChange={formikCustom.handleChange}
                value={formikCustom.values.size}
                onFocusOut={formikCustom.handleBlur}
              />
              {formikCustom.errors.size && formikCustom.touched.size ? (
                <div className="pho_14_regular text-danger">
                  {formikCustom.errors.size}
                </div>
              ) : null} */}
            </Col>
            {/* <Col md={4} className="pb-3">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-UoM">UOM</InputLabel>
                <Select
                  disabled={true}
                  value={state.UoM}
                  //value={formikCustom.values.uom}
                  name="uom"
                  onChange={selecthandleChange}
                  label="UoM"
                  inputProps={{
                    name: "UoM",
                    id: "outlined-UoM",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value={"Plate"}>Plate</MenuItem>
                  <MenuItem value={"Bowl"}>Bowl</MenuItem>
                  <MenuItem value={"KG"}>KG</MenuItem>
                </Select>
                {formikCustom.errors.uom && formikCustom.touched.uom ? (
                  <div className="pho_14_regular text-danger">
                    {formikCustom.errors.uom}
                  </div>
                ) : null}
              </FormControl>
            </Col> */}
          </Row>
        </Col>
      </Row>
      <AddButtonIconComponent
        buttonText="Save"
        fontIcon="fa fa-plus"
        colorCss="blue"
        onClick={(e) => onClickAddNew(e)}
      />
    </React.Fragment>
  );
};

export default ServicesEditReuse;
